import { gql } from "@apollo/client";

// QUERIES

export const CATALOGS_QUERY = gql`
  query GetCatalogs {
    professionalAssociations {
      id
      name {
        id
        de
        en
        fr
        it
      }
    }
    diplomas {
      id
      name {
        id
        de
        en
        fr
        it
      }
    }
    competences {
      id
      name {
        id
        de
        en
        fr
        it
      }
    }
    roles {
      id
      name {
        id
        de
        en
        fr
        it
      }
    }
    referenceRoles {
      id
      name {
        id
        de
        en
        fr
        it
      }
    }
    skills {
      id
      name {
        id
        de
        en
        fr
        it
      }
    }
    languages {
      id
      name {
        id
        de
        en
        fr
        it
      }
    }
    factKeys {
      id
      name {
        id
        de
        en
        fr
        it
      }
    }
    wikiTags {
      id
      name {
        id
        de
        en
        fr
        it
      }
    }
  }
`;
